import { render, staticRenderFns } from "./colSelector.vue?vue&type=template&id=3b819918&scoped=true&"
import script from "./colSelector.vue?vue&type=script&lang=js&"
export * from "./colSelector.vue?vue&type=script&lang=js&"
import style0 from "./colSelector.vue?vue&type=style&index=0&id=3b819918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b819918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VContainer,VList,VListItem,VListItemContent,VListItemTitle,VRow,VSubheader})
